import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { State } from './layout.reducer';

export const getState = (state: AppState): State => state.layout;

export const isSidebarMinimised = createSelector(getState, (state: State): boolean => state.sidebarMinimised);

export const isFullScreenMode = createSelector(getState, (state: State): boolean => state.fullScreenMode);
